import * as yup from 'yup';
import { SurveyQuestion } from "../../redux/types/survey";

export const QuestionSchema = yup.object().shape({
  text: yup.string().required(),
  type: yup.string().required(),
});

export const AnswerSchema = yup.object().shape({
  type: yup.number().required(),
  choices: yup
    .array()
    .of(yup.string().required())
    .required(),
});


export const getMaxQuestions = (variant: 'preTour' | 'postTour') => (variant === 'preTour' ? 5 : 2);

export const normalizeQuestion = (q: SurveyQuestion) => {
  const text = (q.text ?? '').trim().toLowerCase();
  const type = Number(q.type);
  const choices = Array.isArray(q.choices)
    ? q.choices.map((c) => (c ?? '').trim().toLowerCase()).join('|')
    : '';
  return `${type}::${text}::${choices}`;
};

export const pickFirstBuilderBlock = (list: SurveyQuestion[]) => {
  const seen = new Set<string>();
  const picked: SurveyQuestion[] = [];

  for (const q of list) {
    const sig = normalizeQuestion(q);
    if (seen.has(sig)) break;
    seen.add(sig);
    picked.push(q);
  }

  return picked;
};
